import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CourseService } from '../../services/course.service';

@Component({
  selector: 'app-session-attachments',
  templateUrl: './session-attachments.component.html',
  styleUrls: ['./session-attachments.component.scss']
})
export class SessionAttachmentsComponent {

  @Input() openAttachmentModal:boolean=false;
  @Input() attachmentsData:any;
  @Output() attachmentsPopupVisible = new EventEmitter<boolean>();

  constructor(private courseService: CourseService){

  }
  
  ngOnInit(){
  }

  closeAttachmentsPopup(){
    this.attachmentsPopupVisible.emit(false);
  }

  downloadAttachment = (fileId: string, fileName: string) => {
    this.courseService.downloadFile(fileId).subscribe((response) => {
      const fileUrl = response.fileUri;
      let downloadLink = document.createElement('a');
      document.body.appendChild(downloadLink);
      downloadLink.setAttribute('style', 'display: none');
      downloadLink.href = fileUrl;
      downloadLink.download = fileName;
      downloadLink.target = '_blank';
      downloadLink.click();
      downloadLink.remove();
    })
  }

}
